module.exports = __webpack_public_path__ + "06755d363bc1a1ea3cd46c99fb52e352.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/BM.svg
// module id = P9Fo
// module chunks = 0